module["exports"] = [
  "PT",
  "CV",
  "UD",
  "PD",
  "Perum"
];


//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/id_ID/company/prefix.js
// module id = 1040
// module chunks = 0